.root {
  display: var(--haus-stripePayment__root__display, flex);
  flex-direction: var(--haus-stripePayment__root__flex-direction, column);
  gap: var(--haus-stripePayment__root__gap, 16px);
  min-height: var(--haus-stripePayment__root__min-height, 480px);
  width: var(--haus-stripePayment__root__width, 100%);
  overflow: var(--haus-stripePayment__root__overflow, visible);
}

.form {
  display: var(--haus-stripePayment__form__display, flex);
  flex-direction: var(--haus-stripePayment__form__flex-direction, column);
  gap: var(--haus-stripePayment__form__gap, 16px);
}

.buttonContainer {
  display: var(--haus-stripePayment__buttonContainer__display, flex);
  justify-content: var(--haus-stripePayment__buttonContainer__justify-content, flex-end);
  gap: var(--haus-stripePayment__buttonContainer__gap, 16px);
}

.error {
  display: var(--haus-stripePayment__error__display, flex);
  justify-content: var(--haus-stripePayment__error__justify-content, space-between);
  align-items: var(--haus-stripePayment__error__align-items, center);
  gap: var(--haus-stripePayment__error__gap, 12px);
  padding: var(--haus-stripePayment__error__padding, var(--haus-spacing-sm, 8px));
  border-radius: var(--haus-stripePayment__error__border-radius, 4px);
  font-size: var(
    --haus-stripePayment__error__font-size,
    var(--haus-typography-body-font-size, 0.875rem)
  );
  font-weight: var(--haus-stripePayment__error__font-weight, 400);
  line-height: var(
    --haus-stripePayment__error__line-height,
    var(--haus-typography-body-line-height, 1.4)
  );
  font-family: var(
    --haus-stripePayment__error__font-family,
    var(--haus-typography-body-font-family, 'Inter, sans-serif')
  );
  color: var(--haus-stripePayment__error__color, #972626);
  background-color: var(--haus-stripePayment__error__background-color, #ffd9d9);
  border: var(--haus-stripePayment__error__border, 1px solid #ffd9d9);
  margin: var(--haus-stripePayment__error__margin, 0);
}
